import React, { useEffect, useState } from 'react';
import { Quote } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const { data, error } = await supabase
        .from('testimonials')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(3);

      if (!error) {
        setTestimonials(data);
      }

      setLoading(false);
    };

    fetchTestimonials();
  }, []);

  const truncateText = (text, limit = 160) => {
    if (!text) return '';
    return text.length > limit ? text.slice(0, limit) + '...' : text;
  };

  return (
    <section className="py-24 bg-gradient-to-b from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">
            Testimonials
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Stories from Happy Adventurers
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-6">
            Real experiences shared by travelers who explored with us.
          </p>

          <Link to="/leave-review">
            <Button className="bg-emerald-600 hover:bg-emerald-700">
              Leave us a review
            </Button>
          </Link>
        </div>

        {/* Content */}
        {loading ? (
          <p className="text-center text-gray-500">Loading reviews...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((t) => (
              <div
                key={t.id}
                className="relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-shadow"
              >
                <Quote className="absolute top-6 right-6 h-10 w-10 text-emerald-100" />

                {/* Name */}
                <h4 className="font-semibold text-gray-900 mb-1">
                  {t.name}
                </h4>

                {/* Place */}
                <p className="text-sm text-gray-500 mb-4">
                  {t.place}
                </p>

                {/* Review */}
                <p className="text-gray-600 leading-relaxed mb-3">
                  {expandedId === t.id
                    ? t.review
                    : truncateText(t.review)}
                </p>

                {/* Read more / less */}
                {t.review && t.review.length > 160 && (
                  <button
                    onClick={() =>
                      setExpandedId(expandedId === t.id ? null : t.id)
                    }
                    className="text-sm text-emerald-600 font-medium hover:underline"
                  >
                    {expandedId === t.id ? 'Read less' : 'Read more'}
                  </button>
                )}

                {/* Trek name */}
                <p className="text-sm text-emerald-600 font-medium mt-4">
                  {t.trek_name}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
